<template>
  <div v-if="order != null">
    <section class="text_center">
      <h2 class="header_underline">銀行振込決済(収納代行システム)</h2>
      <p>購入内容</p>
      <table class="table white brown">
        <tr>
          <th>決済金額</th>
          <th>追加ポイント</th>
        </tr>
        <tr>
          <td>{{ order.price.toLocaleString() }}円</td>
          <td>{{ order.point }}pt</td>
        </tr>
      </table>
      <form
        action=""
        method="post"
        class="form"
      >
        <div>
          <p>
            <button
              type="submit"
              class="btn arrow"
              :disabled="isSend"
              @click="submit"
            >決済する</button>
          </p>
          <div class="caution">
            <p class="text_left font_annotation--text">上記ご確認の上、「決済する」を押してください。</p>
          </div>
        </div>
      </form>
    </section>
  </div>
</template>
<script>
import { GET_BANK_ANOTHERLANE_PREPARE } from '@/store/point/actions'

export default {
  name: 'PointBankAnotherlaneConfirm',
  props: {
    order: Object
  },
  data () {
    return {
      user: this.$store.getters.loginUser || null,
      isSend: false,
      bank: {}
    }
  },
  methods: {
    submit () {
      this.isSend = true
      this.getBankAnotherlanePrepare()
    },
    getBankAnotherlanePrepare () {
      this.$store.dispatch(GET_BANK_ANOTHERLANE_PREPARE, {
        id: this.order.id
      })
        .then((data) => {
          if (data.bank) {
            this.bank = data.bank
            this.$router.pushIsses({
              name: 'PointBankAnotherlaneApplicationComplete',
              params: {
                bank: this.bank
              }
            })
          } else {
            this.$router.pushIsses({ name: 'PointBankAnotherlaneError' })
          }
        })
        .catch(() => {
          this.$router.pushIsses({ name: 'PointBankAnotherlaneError' })
        })
    }
  },
  created () {
    if (this.order == null) {
      this.$router.pushIsses({ name: 'PointBankAnotherlaneForm' })
    }
  }
}
</script>
